<div class="logout-page">
  <h1 class="logout-page__title">Закройте браузер, чтобы выйти из системы.</h1>
  <a routerLink="/main" class="logout-page__link link link--dotted-blue-dark">ВЕРНУТЬСЯ НА САЙТ</a>
</div>
